document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelectorAll(".cs-book-slider-container")
    .forEach(function (container) {
      const totalSlides = parseInt(container.dataset.slidesCount) || 0;
      const slidesPerViewDesktop = 6;
      const slidesPerViewTablet = 2;
      const slidesPerViewMobile = 1;

      let swiperInstance;

      function initSwiper() {
        const screenWidth = window.innerWidth;

        const isMobile = screenWidth < 768;
        const slidesPerView = isMobile
          ? screenWidth < 480
            ? slidesPerViewMobile
            : slidesPerViewTablet
          : slidesPerViewDesktop;

        const shouldLoop = isMobile || totalSlides > slidesPerView;
        const shouldAutoplay = isMobile || totalSlides > slidesPerView;

        // Destroy previous instance if exists
        if (swiperInstance) {
          swiperInstance.destroy(true, true);
        }

        // Initialize new Swiper with pagination and custom navigation
        swiperInstance = new Swiper(container.querySelector(".swiper"), {
          slidesPerView: slidesPerView,
          spaceBetween: 20,
          loop: shouldLoop,
          autoplay: shouldAutoplay
            ? { delay: 3000, disableOnInteraction: false }
            : false,
          pagination: {
            el: container.querySelector(".swiper-pagination"),
            clickable: true
          },
          navigation: {
            nextEl: container.querySelector(".cs-swiper-button-next"),
            prevEl: container.querySelector(".cs-swiper-button-prev")
          },
          rtl: document.dir === "rtl",
          breakpoints: {
            0: {
              slidesPerView: slidesPerViewMobile
            },
            480: {
              slidesPerView: slidesPerViewTablet
            },
            768: {
              slidesPerView: slidesPerViewDesktop
            }
          }
        });
      }

      // Initial load
      initSwiper();

      // Re-initialize on window resize
      window.addEventListener("resize", function () {
        initSwiper();
      });
    });
});
